var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_23248_10950)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.544922,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#747480",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22647 15.1654C5.92655 15.4653 5.92043 15.9979 6.23259 16.31C6.55088 16.6222 7.0834 16.6161 7.3772 16.3223L11.0008 12.6987L14.6182 16.3161C14.9243 16.6222 15.4507 16.6222 15.7628 16.31C16.075 15.9917 16.075 15.4715 15.7689 15.1654L12.1515 11.548L15.7689 7.92442C16.075 7.61838 16.0811 7.09198 15.7628 6.77982C15.4507 6.46765 14.9243 6.46765 14.6182 6.7737L11.0008 10.3911L7.3772 6.7737C7.0834 6.47377 6.54476 6.46153 6.23259 6.77982C5.92043 7.09198 5.92655 7.63062 6.22647 7.92442L9.84392 11.548L6.22647 15.1654Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_23248_10950",
    x: -54.3656,
    y: -53.8207,
    width: 130.731,
    height: 130.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27.1828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23248_10950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23248_10950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/Close-1.6745a7a7d58f6d9dc9d9f537160d17a2.svg";
export { ForwardRef as ReactComponent };